import { inject } from 'inversify';

import { service } from '@/decorators/service';
import { SignalrListener, SignalrMessage } from '@/decorators/signalr';
import { Logger } from '@/services/Logger';
import { Signalr } from '@/services/signalr/Signalr';
import { UnitTemplateStore } from '@/stores/UnitTemplateStore';
import { orderByField } from '@/utils/orderBy';
import type { IUnitTemplate } from '~/api/IUnitTemplate';
import type { IDispatchMessage } from '~/api/messages/IDispatchMessage';
import { IUnitTemplatesMsg } from '~/api/messages/IUnitTemplatesMsg';

@SignalrListener
@service(UnitTemplateManager)
export class UnitTemplateManager {
  @inject(Logger) protected logger: Logger;
  @inject(Signalr) protected signalr: Signalr;
  @inject(UnitTemplateStore) protected unitTemplateStore: UnitTemplateStore;

  // Expose current unit templates
  get all(): IUnitTemplate[] {
    const units = this.unitTemplateStore.all();
    return orderByField(units, this.unitTemplateStore.valueKey);
  }

  find(id: string | number) {
    return this.unitTemplateStore.find(id);
  }

  @SignalrMessage('UnitTemplatesMsg')
  async onUnitTemplatesMsgReceived(payload: IUnitTemplatesMsg & IDispatchMessage) {
    this.unitTemplateStore.set([]);
    this.unitTemplateStore.batchUpdate(payload.templates);
  }
}
